import * as React from "react"
export const Svg_050 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <path fill="url(#a)" d="M0 5.384h12.157v6.23H0v-6.23Z" />
    <path
      fill="url(#b)"
      d="M0 15.013v27.974h59V15.013H0Zm23.565 5.342L38.44 29l-14.874 8.645v-17.29Z"
    />
    <path fill="url(#c)" d="M31.228 5.384h12.158v6.23H31.228v-6.23Z" />
    <path fill="url(#d)" d="M15.614 5.384H27.77v6.23H15.614v-6.23Z" />
    <path fill="url(#e)" d="M27.023 26.312v5.376L31.646 29l-4.623-2.688Z" />
    <path fill="url(#f)" d="M0 46.385h12.157v6.23H0v-6.23Z" />
    <path fill="url(#g)" d="M31.228 46.385h12.158v6.23H31.228v-6.23Z" />
    <path fill="url(#h)" d="M46.843 5.384H59v6.23H46.843v-6.23Z" />
    <path fill="url(#i)" d="M46.843 46.385H59v6.23H46.843v-6.23Z" />
    <path fill="url(#j)" d="M15.614 46.385H27.77v6.23H15.614v-6.23Z" />
    <defs>
      <linearGradient
        id="a"
        x1={2.811}
        x2={4.716}
        y1={6.319}
        y2={12.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.644}
        x2={21.661}
        y1={19.209}
        y2={46.575}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={34.04}
        x2={35.944}
        y1={6.319}
        y2={12.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={18.425}
        x2={20.33}
        y1={6.319}
        y2={12.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={28.092}
        x2={30.797}
        y1={27.119}
        y2={30.885}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={2.811}
        x2={4.716}
        y1={47.32}
        y2={53.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={34.04}
        x2={35.944}
        y1={47.32}
        y2={53.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={49.654}
        x2={51.559}
        y1={6.319}
        y2={12.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={49.654}
        x2={51.559}
        y1={47.32}
        y2={53.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={18.425}
        x2={20.33}
        y1={47.32}
        y2={53.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)